import { Card, Col, Form, Row } from 'react-angle-dashboard-components'
import { GrayText } from '../../style'

interface ISelectCardProps {
  title: string
  image: string | undefined
  description: string
  onClick: (isSelected: boolean) => void
  checked: boolean
  checkGroupName: string | undefined
  checkType?: 'checkbox' | 'radio'
  disabled?: boolean
}

const SelectCard = ({
  title,
  image,
  description,
  onClick,
  checked,
  checkGroupName,
  checkType = 'radio',
  disabled = false
}: ISelectCardProps) => (
  <Card
    className={`py-2 px-3 user-select-none ${checked ? 'border-primary' : ''}`}
    style={{
      width: 275,
      height: '100%',
      overflow: 'hidden'
    }}
    onClick={() => !disabled && onClick(!checked)}
  >
    <Col>
      <Row className="d-flex justify-content-end">
        <Form.Check
          name={checkGroupName}
          style={{
            width: 15,
            height: 15
          }}
          type={checkType}
          checked={checked}
          readOnly
          disabled={disabled}
        />
      </Row>
      <Row className="d-flex justify-content-center align-items-center mb-3">
        <img
          src={image}
          alt=""
          style={{
            height: 52,
            width: '80%',
            objectFit: 'contain'
          }}
        />
      </Row>
      <Row>
        <span
          className="mb-1"
          style={{
            fontWeight: 500,
            fontSize: 16
          }}
        >
          {title}
        </span>
      </Row>
      <Row>
        <GrayText
          style={{
            wordBreak: 'break-word'
          }}
        >
          {description}
        </GrayText>
      </Row>
    </Col>
  </Card>
)

export default SelectCard
